import ToolCallRecord from "models/view-models/conversations/tool-call-record";
import ServiceFactory from "utilities/services/service-factory";
import { ToolCallStatusAction } from "models/enumerations/conversations/tool-call-interaction-action";

// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

export interface ToolCallInteractionPathParams {
    toolCallId: string;
}

export interface CreateToolCallInteractionParams {
    action: ToolCallStatusAction;
    resource?: object;
}

// #endregion Interfaces
// -------------------------------------------------------------------------------------------------

const endpoint = "tool-calls/:toolCallId/interaction";

const ToolCallInteractionService = {
    create: ServiceFactory.updateFromPutParams<
        ToolCallRecord,
        CreateToolCallInteractionParams,
        ToolCallInteractionPathParams
    >(ToolCallRecord, endpoint),
};

export default ToolCallInteractionService;
